import { c as _c } from "react/compiler-runtime";
import { motion } from 'framer-motion';
import noop from 'lodash.noop';
import React from 'react';
import ChevronDownIcon from '@/assets/icons/heroIcons/Chevron-down.svg';
import imageBrain from '@/assets/images/brain-holds-card.png';
import imageHeart from '@/assets/images/heart-holds-card.png';
import { mergeClasses } from '@/utils/style';
import useMediaQuery from '@/hooks/useMediaQuery';
import { getMediaQuery } from '@/styles/sizes';
import { Text, Headline } from '@/components/typography';
import { InfoBox as InfoBoxType, InfoBoxVariant } from './types';
import Image from 'next/image';
export function InfoBox(t0) {
  const $ = _c(49);
  const {
    icon,
    title,
    anchorKey,
    paragraph,
    variant,
    isOpen,
    onClick,
    character
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getMediaQuery("xl");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const isDesktop = useMediaQuery(t1);
  const t2 = variant === "basic" && "bg-white";
  const t3 = variant === "inverted" && "bg-blue-500 text-white";
  let t4;
  if ($[1] !== t2 || $[2] !== t3) {
    t4 = mergeClasses("relative w-full cursor-default rounded-2xl p-4 text-left lg:max-w-[23rem] lg:rounded-4xl lg:p-8 lg:pb-10", t2, t3);
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== isDesktop || $[5] !== onClick) {
    t5 = () => isDesktop ? noop : onClick();
    $[4] = isDesktop;
    $[5] = onClick;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = isDesktop ? undefined : isOpen;
  let t7;
  if ($[7] !== character) {
    t7 = character === "brain" && <Image src={imageBrain} width={182} height={205} alt="" className="absolute right-full bottom-0 hidden translate-x-[25px] translate-y-6 lg:block" />;
    $[7] = character;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== character) {
    t8 = character === "heart" && <Image src={imageHeart} width={254} height={324} alt="" className="absolute bottom-0 left-full hidden -translate-x-[14px] translate-y-6 lg:block" />;
    $[9] = character;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = variant === "basic" && "text-blue-500";
  let t10;
  if ($[11] !== t9) {
    t10 = mergeClasses("block h-10 w-10 lg:h-12 lg:w-12", t9, "iconContainer");
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== icon || $[14] !== t10) {
    t11 = <span className={t10}>{icon}</span>;
    $[13] = icon;
    $[14] = t10;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== anchorKey || $[17] !== title) {
    t12 = <Headline as="h3" variant="h5" anchorKey={anchorKey} className="text-base lg:mt-6">{title}</Headline>;
    $[16] = anchorKey;
    $[17] = title;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  const t13 = isOpen ? 180 : 0;
  let t14;
  if ($[19] !== t13) {
    t14 = {
      rotate: t13
    };
    $[19] = t13;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  let t16;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      rotate: 0
    };
    t16 = <ChevronDownIcon aria-hidden="true" />;
    $[21] = t15;
    $[22] = t16;
  } else {
    t15 = $[21];
    t16 = $[22];
  }
  let t17;
  if ($[23] !== t14) {
    t17 = <motion.div className="ml-auto flex transition-transform lg:hidden" style={t14} initial={t15}>{t16}</motion.div>;
    $[23] = t14;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== t11 || $[26] !== t12 || $[27] !== t17) {
    t18 = <div className="flex items-center gap-4 lg:flex-col lg:items-start lg:gap-0">{t11}{t12}{t17}</div>;
    $[25] = t11;
    $[26] = t12;
    $[27] = t17;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  const t19 = isDesktop ? "open" : "collapsed";
  const t20 = isOpen || isDesktop ? "open" : "collapsed";
  let t21;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = {
      open: {
        opacity: 1,
        height: "auto",
        marginTop: "1rem"
      },
      collapsed: {
        opacity: 0,
        height: 0,
        marginTop: 0
      }
    };
    $[29] = t21;
  } else {
    t21 = $[29];
  }
  const t22 = variant === "inverted" && "text-light-gray-100";
  const t23 = variant === "basic" && "text-gray-700";
  let t24;
  if ($[30] !== t22 || $[31] !== t23) {
    t24 = mergeClasses(t22, t23);
    $[30] = t22;
    $[31] = t23;
    $[32] = t24;
  } else {
    t24 = $[32];
  }
  let t25;
  if ($[33] !== paragraph || $[34] !== t24) {
    t25 = <Text as="p" variant="p3" className={t24}>{paragraph}</Text>;
    $[33] = paragraph;
    $[34] = t24;
    $[35] = t25;
  } else {
    t25 = $[35];
  }
  let t26;
  if ($[36] !== t19 || $[37] !== t20 || $[38] !== t25) {
    t26 = <motion.div initial={t19} animate={t20} variants={t21} className="overflow-hidden">{t25}</motion.div>;
    $[36] = t19;
    $[37] = t20;
    $[38] = t25;
    $[39] = t26;
  } else {
    t26 = $[39];
  }
  let t27;
  if ($[40] !== isDesktop || $[41] !== t18 || $[42] !== t26 || $[43] !== t4 || $[44] !== t5 || $[45] !== t6 || $[46] !== t7 || $[47] !== t8) {
    t27 = <button className={t4} type="button" onClick={t5} aria-expanded={t6} disabled={isDesktop}>{t7}{t8}{t18}{t26}</button>;
    $[40] = isDesktop;
    $[41] = t18;
    $[42] = t26;
    $[43] = t4;
    $[44] = t5;
    $[45] = t6;
    $[46] = t7;
    $[47] = t8;
    $[48] = t27;
  } else {
    t27 = $[48];
  }
  return t27;
}